import axios from "axios";

import { HotelPriceQuoteScheduleRequestV2 } from "redmond";
import {
  purchaseApi,
  Product,
  ProductOpaqueValue,
} from "@b2bportal/purchase-api";
import { getPurchaseContext } from "@capone/common";

export const schedulePriceQuoteV0 = ({
  req,
  type = Product.Hotel,
}: {
  req: HotelPriceQuoteScheduleRequestV2;
  type?: Product;
}): Promise<String> =>
  new Promise((resolve, reject) => {
    try {
      // For Hotels CFAR the request expected is type HotelPriceQuoteScheduleRequestV2 which includes the cfarQuoteId
      const productOpaqueValue: ProductOpaqueValue = {
        type,
        value: req as object,
      };

      const res = purchaseApi(axios).apiV0PurchaseQuoteSchedulePost({
        emailAddress: req.hotelQuoteRequest.emailAddress,
        request: productOpaqueValue,
        purchaseContext: getPurchaseContext(),
      });

      res.then((body) => resolve(body.data.value)).catch((e) => reject(e));
    } catch (e) {
      reject(e);
    }
  });
